import { onDocumentReady } from "@story/story_assets";

function playVideo(selected, all) {
	for (const element of all) {
		const video = element.querySelector("video");
		if (video) {
			video.pause();
		}
	}

	const selectedVideo = selected.querySelector("video");
	if (selectedVideo) {
		selectedVideo.play();
	}
}

onDocumentReady(() => {
	const instareels = document.querySelectorAll(".instareel");

	for (const element of instareels) {
		element.addEventListener("mouseenter", () => {
			playVideo(element, instareels);
		});
	}
});
